import { useLocation, useNavigate } from "react-router-dom";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { useSaved, useToggleSave } from "../api/hooks";
import { apiError } from "../api/client";
import { toast } from "../components/ui/sonner";

const SaveButton = ({ kind = "offer", id, className = "", showLabel = false }) => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { data: saved } = useSaved();
    const toggle = useToggleSave();

    const list = kind === "offer" ? saved?.offers : saved?.brands;
    const isSaved = Boolean(list?.some((x) => x.id === id));

    const onClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!user) {
            toast.info("Log in to save offers");
            navigate("/login", { state: { from: location.pathname } });
            return;
        }
        toggle.mutate(
            { kind, id, save: !isSaved },
            {
                onSuccess: () => toast.success(isSaved ? "Removed from saved" : "Saved to your account"),
                onError: (err) => toast.error(apiError(err)),
            }
        );
    };

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={toggle.isPending}
            aria-label={isSaved ? "Remove from saved" : "Save"}
            aria-pressed={isSaved}
            data-testid={`save-button-${id}`}
            className={`inline-flex items-center gap-1.5 rounded-full transition-all duration-300 ${
                isSaved
                    ? "bg-saffron text-white"
                    : "border border-ink/10 bg-white/90 text-smoke hover:border-saffron hover:text-saffron"
            } ${showLabel ? "px-5 py-3 text-sm font-medium" : "h-9 w-9 justify-center"} ${className}`}
        >
            {isSaved ? <BookmarkCheck className="h-4 w-4" /> : <Bookmark className="h-4 w-4" />}
            {showLabel && (isSaved ? "Saved" : "Save")}
        </button>
    );
};

export default SaveButton;
